module.exports = __webpack_public_path__ + "static/media/android (2).eef110f2.svg";